import { render, staticRenderFns } from "./KnProductOptionsType.vue?vue&type=template&id=23830730"
import script from "./KnProductOptionsType.js?vue&type=script&lang=js&external"
export * from "./KnProductOptionsType.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports